__turbopack_context__.v({
  "itemDecpration": "VebinarCard-module-scss-module__MbfN2a__itemDecpration",
  "itemDescription": "VebinarCard-module-scss-module__MbfN2a__itemDescription",
  "itemFooter": "VebinarCard-module-scss-module__MbfN2a__itemFooter",
  "itemHeader": "VebinarCard-module-scss-module__MbfN2a__itemHeader",
  "itemImage": "VebinarCard-module-scss-module__MbfN2a__itemImage",
  "itemText": "VebinarCard-module-scss-module__MbfN2a__itemText",
  "itemWrapper": "VebinarCard-module-scss-module__MbfN2a__itemWrapper",
});
